import { apiCall } from './apiClient';

// --- User Logs Endpoints ---

export const getPendingUsers = () =>
  apiCall('/authentication/auths/pending-users');

export const getApprovedUsers = () =>
  apiCall('/authentication/auths/approved-users');

export const getRejectedUsers = () =>
  apiCall('/authentication/auths/rejected-users');

export const getBlockedUsers = () =>
  apiCall('/authentication/auths/blocked-users');

export const approveUser = (userId) =>
  apiCall(`/authentication/auths/approve-user/${userId}`, {
    method: 'PUT'
  });

export const rejectUser = (userId) =>
  apiCall(`/authentication/auths/reject-user/${userId}`, {
    method: 'DELETE'
  });

export const blockUser = (userId) =>
  apiCall(`/authentication/auths/block-user/${userId}`, {
    method: 'PUT'
  });

// --- Dashboard Endpoints ---

  export const getCategoryCounts = () =>
  apiCall('/inventory/inven/category-counts');

// --- User Logs Endpoints ---

export const getAuditLogs = () =>
  apiCall('/inventory/inven/audit-logs');